// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"37597453","455":"10a9a3c8"}[chunkId] + ".chunk.js";
};